module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_5.1779d333.png";